import React from 'react'

import "./Custom.css";

const Custom = (props) => {
  return (
    <div>
      <label className="container">
        <input type="checkbox" checked={props.checked === true} onChange={props.onChange}/>
        <span className="checkmark"></span>
      </label>
    </div>
  )
}

export default Custom;
